import { render, staticRenderFns } from "./WinVoyageView.vue?vue&type=template&id=4675323c&scoped=true"
import script from "./WinVoyageView.vue?vue&type=script&setup=true&lang=ts"
export * from "./WinVoyageView.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./WinVoyageView.vue?vue&type=style&index=0&id=4675323c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4675323c",
  null
  
)

export default component.exports